import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    TextField,
    Typography,
    Paper
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import apiClient from '../../utils/apiClient';
import { toast } from 'react-toastify';

const AddEditTimeSlots = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const editingSlot = state?.slot;
    const [error,setError]=useState('')

    const [formData, setFormData] = useState({
        time: '',
        isPeakHour: false,
        peakHourAmount: 0,
        isActive: true
    });

    useEffect(() => {
        if (editingSlot) {
            setFormData({
                time: editingSlot.time || '',
                isPeakHour: editingSlot.isPeakHour || false,
                peakHourAmount: editingSlot.peakHourAmount || 0,
                isActive: editingSlot.isActive || false
            });
        }
    }, [editingSlot]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { isPeakHour, peakHourAmount, ...rest } = formData;

        const payload = {
            ...rest,
            isPeakHour,
            ...(isPeakHour && { peakHourAmount })
        };


        try {
            let res;
            if (editingSlot) {
                res = await apiClient.put(`/slots/updateslots/${editingSlot.id}`, payload);
            } else {
                res = await apiClient.post(`/slots/timeslots`, payload);
            }
             if(res.data.status === true){
                navigate('/display-timeslots')
                toast.success(res.data.message)
             }

        } catch (error) {
            setError(error?.response?.data?.message || "Submission failed");
        }
    };

    return (
        <Box p={3} maxWidth="500px" mr="auto">
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h5" mb={3}>
                    {editingSlot ? 'Edit Time Slot' : 'Create New Time Slot'}
                </Typography>

                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Time"
                        name="time"
                        type='time'
                        value={formData.time}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                    />

                    {/* <FormControlLabel
                        control={
                            <Checkbox
                                name="isPeakHour"
                                checked={formData.isPeakHour}
                                onChange={handleChange}
                            />
                        }
                        label="Is Peak Hour"
                    /> */}

                    {formData.isPeakHour && (
                        <TextField
                            label="Peak Hour Price"
                            name="peakHourAmount"
                            type="number"
                            value={formData.peakHourAmount}
                            onChange={handleChange}
                            fullWidth
                            required
                            sx={{ mb: 2, mt: 2 }}
                        />
                    )}

                    <FormControlLabel
                        control={
                            <Checkbox
                                name="isActive"
                                checked={formData.isActive}
                                onChange={handleChange}
                            />
                        }
                        label="Is Active"
                    />
                    {error && 
                    <Typography color='error' variant='body2'>
                        {error}
                    </Typography>
                    }

                    <Box mt={3} display="flex" justifyContent="space-between">
                        <Button variant="contained" color="primary" type="submit">
                            {editingSlot ? 'Update' : 'Create'}
                        </Button>
                        <Button variant="outlined" color="secondary" onClick={() => navigate(-1)}>
                            Cancel
                        </Button>
                    </Box>
                </form>
            </Paper>
        </Box>
    );
};

export default AddEditTimeSlots;
